export default __webpack_public_path__ + "static/media/hero-2.9757a45b.jpg";